import type {
  CoachDirectoryResponseOrganizationRosterResponseRelatedPagedData,
  ConferenceFilter,
  DraftByOrgResponse,
  DraftByStarsResponse,
  DraftByStarsSummaryResponse,
  DraftPickStarsResponse,
  DraftPickStateResponsePagedData,
  DraftPickYearResponsePagedData,
  NilDashboardValuationBreakdownResponsePagedData,
  NilRankingResponseRelatedNilRankingResponseRelatedPagedData,
  OrganizationDraftRankingSummaryResponse,
  OrganizationDraftYearsResponsePagedData,
  OrganizationRankingSummaryResponse,
  OrgDraftByStarsSummaryResponse,
  Pagination,
  PlayerItemResponsePagedData,
  PlayerItemResponsePositionResponseRelatedPagedDataPagedData,
  PlayerItemVisitResponseRelatedVisitDateRelatedPagedDataPagedData,
  PlayerTransferRelatedTransferResponseRelatedPagedData,
  PositionFilter,
  RecruitmentStatus,
  RequestParams,
  RosterHeaderResponse,
  RosterItemResponseOrganizationRosterResponseRelatedPagedData,
  RpmPickListPredictionAccuraciesRelatedPagedData,
  RpmResponse,
  SiteDetailResponse,
  SportFilter,
  StateResponse,
  Status,
  Team,
  TeamConferenceFilter,
  TeamFilter,
  TeamTransferPortalRankingResponseRankingResponseRelatedPagedData,
  // UserJwtResponse is used in a jsdoc and incorrectly identified as unused
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  UserJwtResponse,
} from '@on3/api';
import { type SiteServerProps } from '@on3/ui-lib/contexts/SiteProvider';
import { type PageType } from '@on3/ui-lib/types/common-props';

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE is a temporary placeholder for types that are currently avaiable via swagger
 * ## Requirements: Put the reason why the interfaces was added
 * ## AUTHOR: on3
 * ---------------------------------------------------------------
 */

// ====================================================
// Addded by Adam on 01-24-2021 These responses are not in swagger
// =====
export interface IUser {
  /**
   * user alias, specific name used primarily for message boards
   *
   * ex: 'lucky'
   */
  a: string;
  /** audience. Not used on front end. ex: 'On3' */
  aud: string;
  /** token expiration. ex: 1623286365 */
  exp: {
    date: number;
  };
  /**
   * has active scription, use to determine if use can access vip content
   * ex: true/false
   */
  has: boolean;
  /** issued at. Not used on front end. ex: "1623264765" */
  iat: string;
  /** issuer. Not used on front end. ex: 'On3' */
  iss: string;
  /**
   * string of user's full name
   * ex: 'John Doe'
   */
  n: string;
  /** The users Login Type. ex: 'Google', 'Email', 'Apple', or 'Facebook' */
  lt?: string;
  /** The users status. ex: 'annual', 'monthly', '' */
  st: string;

  /** The users sites subscribed to */
  si?: number[];

  /** Promotion eligible. Is the user able to get a promotion.  */
  pe: boolean;
  /** A list of the users plans. ex: '33,44' */
  pl: string;
  /**
   * string list of user's roles
   *
   * ex: 'administrator,author,contributor,editor,subscriber'
   */
  rg: string[] | null;
  /** Player Key. If user is authenticate, this is the player key */
  pk?: string;
  /** Player Keys. */
  pks?: number[];
  /** subject. Not used on front end. ex: 'On3' */
  sub: string;
  /** user's unique ID. ex: '8' */
  uid: string;
  /** User JWT Token */
  jwt?: string | null;
  /** User Email */
  e?: string | null;
  requestParams?: RequestParams;
}

/**
 * Roles/groups that can be assigned to a user. Defined as a string from the API in
 * {@link UserJwtResponse.roles} and {@link IUser.rg}.
 */
export enum UserRole {
  AccountingAdmin = 'accounting_admin',
  Administrator = 'administrator',
  Author = 'author',
  Contributor = 'contributor',
  Cs1 = 'cs1',
  CSAdmin = 'cs_admin',
  Developer = 'developer',
  Editor = 'editor',
  GraphicEdits = 'rdb_graphic_edits',
  NilDisputeAdmin = 'nil_dispute_admin',
  NilValuationAdmin = 'nil_valuation_admin',
  PublisherDashboardAdmin = 'admin_publisher_dashboard',
  PublisherDashboard = 'publisher_dashboard',
  Rdb1 = 'rdb1',
  Rdb2 = 'rdb2',
  Rdb3 = 'rdb3',
  Rdb4 = 'rdb4',
  Rdb5 = 'rdb5',
  ShowsAdmin = 'shows_admin',
  GameScorer = 'game_scorer',
  VerifiedAthlete = 'verified_athlete',
  TrendingAdmin = 'trending_admin',
  SocialAdmin = 'social_admin',
  Notifications = 'notifications',
  ProfileAdmin = 'profile_edit',
}

export interface IGenericPageProps {
  siteData: SiteServerProps;
  userData?: IUser | null;
  // TODO: make this required in future task
  pageType?: PageType | null;
}

interface IInterestProps {
  orgInterest?: number;
  totalInterest?: number;
  recruitmentKey?: number;
}

export interface IPlansComponentProps {
  siteDetails?: SiteDetailResponse;
}

export interface IPlansProps extends IPlansComponentProps, IGenericPageProps {}

export interface IInterestListFiltersProps {
  years?: number[];
  sports?: SportFilter[];
  status?: string[];
  teams?: TeamConferenceFilter[];
  className?: string;
  selectedInterest?: string;
}

export interface ITransferStatus extends Status {
  lastTeam?: Team;
  className?: string;
  predictions?: RpmResponse[] | null;
  year?: number | null;
  slug?: string | null;
}

export interface IPredictionStatus {
  className?: string;
  predictions?: RpmResponse[] | null;
  recruitmentKey?: number | null;
  slug?: string | null;
}
// ====================================================
// Addded by Adam on 01-24-2021 Shared page response between all interest pages with filters
// ====
export interface ICommitsIndexProps extends IGenericPageProps {
  commitList?: PlayerItemResponsePagedData;
  teams?: TeamConferenceFilter[];
  years?: number[];
  sports?: SportFilter[];
  status?: string[];
  conferences?: ConferenceFilter[];
  teamRank?: OrganizationRankingSummaryResponse;
  title: string;
  toggled: boolean;
}
export interface IOffersIndexProps extends IGenericPageProps {
  offersList?: PlayerItemResponsePositionResponseRelatedPagedDataPagedData;
  teams?: TeamConferenceFilter[];
  years?: number[];
  sports?: SportFilter[];
  status?: string[];
  conferences?: ConferenceFilter[];
  teamRank?: OrganizationRankingSummaryResponse;
  title: string;
  toggled: boolean;
}
export interface IVisitsIndexProps extends IGenericPageProps {
  visitsList?: PlayerItemVisitResponseRelatedVisitDateRelatedPagedDataPagedData;
  teams?: TeamConferenceFilter[];
  years?: number[];
  sports?: SportFilter[];
  status?: string[];
  conferences?: ConferenceFilter[];
  teamRank?: OrganizationRankingSummaryResponse;
  title: string;
  toggled: boolean;
}

export interface ITeamRosterProps extends IGenericPageProps {
  rosterList: RosterItemResponseOrganizationRosterResponseRelatedPagedData;
  rosterHeader: RosterHeaderResponse;
  teams: TeamConferenceFilter[];
  years: number[];
  sports: SportFilter[];
  title: string;
}

export interface IDraftByStarsProps extends IGenericPageProps {
  draftByStars: {
    pagination: Pagination;
    list: DraftByStarsResponse[];
  };
  summary: DraftByStarsSummaryResponse;
  filters: {
    sports: SportFilter[];
    years: number[];
  };
}
export interface IRosterListProps extends IGenericPageProps {
  roster?: RosterItemResponseOrganizationRosterResponseRelatedPagedData;
  rosterValue?: NilDashboardValuationBreakdownResponsePagedData;
  filters: {
    sports: SportFilter[];
    years: number[];
    teams: TeamConferenceFilter[];
  };
}
export interface ICoachRosterListProps extends IGenericPageProps {
  coaches?: CoachDirectoryResponseOrganizationRosterResponseRelatedPagedData;
  filters: {
    sports: SportFilter[];
    teams: TeamConferenceFilter[];
  };
}

export interface IPredictionCenterPageProps extends IGenericPageProps {
  title?: string | null;
  predictions?: RpmPickListPredictionAccuraciesRelatedPagedData;
  filters: {
    sports: SportFilter[];
    teams: TeamConferenceFilter[];
    years: number[];
  };
}

export interface TransferPortalPageProps {
  hideFilters?: boolean;
  playerData: PlayerTransferRelatedTransferResponseRelatedPagedData | null;
  filters: {
    positions: PositionFilter[] | null;
    sports: SportFilter[] | null;
    years: number[] | null;
    teams: TeamConferenceFilter[] | null;
  };
  pageTitle?: string;
}

export interface ITransferPortalTeamRankingsPageProps {
  teamRankings?: TeamTransferPortalRankingResponseRankingResponseRelatedPagedData | null;
  filters: {
    sports: SportFilter[];
    years: number[];
    conferences: ConferenceFilter[];
  };
  pageTitle?: string;
}
export interface TPTeamRankingsPageProps
  extends IGenericPageProps,
    ITransferPortalTeamRankingsPageProps {}

export interface ITransferPortalStatusTypes {
  value: string;
  label:
    | 'Status'
    | 'Best-Available'
    | 'Withdrawn'
    | 'Best'
    | keyof typeof RecruitmentStatus;
}

export interface IDraftHistoryPageProps extends IGenericPageProps {
  draftList: OrganizationDraftYearsResponsePagedData;
  modules: {
    yearPicks: DraftPickYearResponsePagedData;
    statePicks: DraftPickStateResponsePagedData;
    starPicks: DraftPickStarsResponse;
    starSummary: OrgDraftByStarsSummaryResponse;
    pickSummary: OrganizationDraftRankingSummaryResponse;
  };
  filters: {
    teams: TeamConferenceFilter[];
    years: number[];
  };
  title: string;
  currentTeam?: TeamFilter | null;
}

export interface IDraftByCategoryProps extends IGenericPageProps {
  draftList: DraftByOrgResponse[];
  filters: {
    teams: TeamConferenceFilter[];
    years: number[];
    positions: PositionFilter[];
  };
  title: string;
  currentTeam?: TeamFilter | null;
}

export interface ErrorData {
  errors: Record<string, string[]>;
  message?: string;
  status: number;
  title: string;
  traceId: string;
  type: string;
}

export interface INilRankingsPageProps extends IGenericPageProps {
  nilRankings: NilRankingResponseRelatedNilRankingResponseRelatedPagedData;
  filters?: {
    teams?: TeamConferenceFilter[];
    positions?: PositionFilter[];
    states?: StateResponse[];
  };
}
